import { Slot } from '@2meters/types'
import { memo } from 'react'
import { usePlace } from 'store/usePlace'
import { useWizardForm } from 'store/useWizardForm'
import { formatTimeToLocale } from 'utils/formatTimeToLocale'
import { needsDarkText } from 'utils/needsDarkText'

interface TimeSlotOptionProps {
  slot: Slot
  index: number
  disabled?: boolean // TODO: If the number of visitors does not fit into the slot, disabled it
  fullDayName: string
  disclosureId: number
}

// eslint-disable-next-line react/display-name
export const TimeSlotOption = memo(
  ({ slot, index, disabled, fullDayName, disclosureId }: TimeSlotOptionProps) => {
    const { wizardForm, updateWizardForm } = useWizardForm()
    const { place } = usePlace()
    const isSelected =
      !disabled &&
      index === wizardForm.selectedTime?.index &&
      fullDayName === wizardForm.selectedTime?.fullDayName
    const startTime = slot.label.split('-')[0]

    const buttonColor = place?.customisation?.buttonColor ?? '#7669ff'
    const selectedTextColor = needsDarkText(buttonColor) ? 'text-gray-900' : 'text-white'

    const onSelect = () => {
      updateWizardForm({
        selectedTime: {
          ...wizardForm.selectedTime,
          label: slot.label,
          startTime: slot.startTime.toISOString(),
          endTime: slot.endTime.toISOString(),
          index,
          fullDayName,
          disclosureId,
          occupancy: slot.occupancy,
          shopCapacity: slot.shopCapacity,
        },
      })
    }

    return (
      <div className='flex justify-center w-3/12 mb-2'>
        <div
          className={(() => {
            const base = 'relative flex flex-col items-center cursor-pointer mr-1 mt-2 rounded-[16px] px-3 py-2 focus:outline-none border'
            const disabledClass = disabled ? 'opacity-25 outline-none' : ''
            if (isSelected) return `${base} bg-custom-primary border-custom-primary ${selectedTextColor} ${disabledClass}`
            // light theme
            const light = 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50 hover:border-gray-400'
            // dark theme
            const dark = 'dark:bg-white/10 dark:text-gray-100 dark:border-gray-300 dark:hover:bg-white/20 dark:hover:border-gray-200'
            return `${base} ${light} ${dark} ${disabledClass}`
          })()}
          onClick={onSelect}
        >
          <p className='text-xs'>{formatTimeToLocale(startTime)}</p>
        </div>
      </div>
    )
  }
)
